import type { TRequestStatus } from "@/types/request-status";

export type TRequestStatusGroup = TRequestStatus["group"];

/**
 * Display order for the request status groups — must match the backend's
 * `_GROUP_DISPLAY_ORDER` (`cognota/request_statuses/models.py`), which is the
 * source of truth for how Workspace Settings > Status > Requests arranges them.
 *
 * Requests use a request-native taxonomy (#4285), not work-item/project state
 * groups.
 */
export const REQUEST_STATUS_GROUPS: readonly TRequestStatusGroup[] = [
  "new",
  "in_review",
  "waitlisted",
  "declined",
  "accepted",
  "delivered",
  "covered",
  "cancelled",
] as const;

export const WORKSPACE_REQUEST_STATUS_GROUP_LABEL_KEYS: Record<TRequestStatusGroup, string> = {
  new: "workspace_settings.request_statuses.group.new",
  in_review: "workspace_settings.request_statuses.group.in_review",
  waitlisted: "workspace_settings.request_statuses.group.waitlisted",
  accepted: "workspace_settings.request_statuses.group.accepted",
  delivered: "workspace_settings.request_statuses.group.delivered",
  declined: "workspace_settings.request_statuses.group.declined",
  cancelled: "workspace_settings.request_statuses.group.cancelled",
  covered: "workspace_settings.request_statuses.group.covered",
};
